<template>
	<!-- 油卡预分配 -->
	<div class="billOperationRecord public_Spacing">
		<div class="pulbic_oparetionBlock" style="margin-bottom: 12px;">
			<div class="public_criteriaRange">

				<div class="public_oparetionBlock_Menu">
					<label class="public_lbSty">车牌号：</label>
					<div class="el-select public_optionSty">
						<div class="el-input el-input--suffix">
							<input class="pulic_carNumber" type="text" placeholder="请输入" v-model="ORMTB540CA04" />
						</div>
					</div>
				</div>
				<!-- <div class="public_oparetionBlock_Menu">
					<label class="public_lbSty">手机号：</label>
					<div class="el-select public_optionSty">
						<div class="el-input el-input--suffix">
							<input class="pulic_carNumber" type="text" placeholder="请输入客户手机号" v-model="ORMTB540CA05" />
						</div>
					</div>
				</div> -->

				<!-- <div class="public_oparetionBlock_Menu">
					<label class="public_lbSty">状态：</label>
					<el-select class="public_optionSty dropDown_Define" v-model="materielMo" @clear="clearFun" clearable
						placeholder="请选择">
						<el-option v-for="item in materielOptions" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div> -->

			</div>

			<div class="public_operatArea">

				<!-- <span class="pulic_operatArea_now pulic_cursor" :class="dateNowDayActive?'public_dateActive':''"
					@click="getNowDay">当日</span>
				<span class="public_operatArea_yesterday pulic_cursor"
					:class="dateYesterdayActive?'public_dateActive':''" @click="getYesterday">昨天</span>
				<span class="pulic_operatArea_now pulic_cursor" :class="dateNowMonthActive?'public_dateActive':''"
					@click="sameMonth">当月</span>
				<span class="public_operatArea_yesterday pulic_cursor"
					:class="dateLastMonthActive?'public_dateActive':''" @click="lastMonth">上月</span>
				<div class="public_operatArea_timePicker pulic_cursor">
					<el-date-picker v-model="date" type="datetimerange" range-separator="至" start-placeholder="开始日"
						end-placeholder="结束日" :picker-options="startDateDisabled" @change="datePickerChange"
						value-format="yyyy-MM-dd HH:mm:ss" class="pulic_cursor">
					</el-date-picker>
				</div> -->

				<div class="public_operatBtn" style="margin-left: 20px;">
					<button @click="queryClick" class="public_saleWater_chaxun pulic_cursor" id="查询"><i
							class="iconfont icon-chaxun"></i>查询</button>
					<button v-if="uobj.pertb005.pertb005cb00 == 'CUS-2'" @click="newlyAdd"
						class="public_saleWater_xinzeng pulic_cursor" id="新增"><i
							class="iconfont icon-tianjia1"></i>新增</button>
					<!-- <button @click="exports" class="public_saleWater_daochu pulic_cursor"     id="导出"><i class="iconfont icon-daochu"></i>导出</button> -->
				</div>
			</div>
		</div>

		<div class="billOperationRecord-table pulbic_table_container">
			<el-table tooltip-effect="dark" :data="tableData" style="width: 100%;"
				:default-sort="{prop: 'waterNum', order: 'descending'}"
				:header-cell-style="{color:'rgba(51,51,51,1)', background:'rgba(184,227,255,1)','font-weight':'bold'}"
				class="public_tableColumn">
				<!--<el-table-column prop="ORMTB440CA00" width="130" fixed="left" label="派单编号">-->
				<!--</el-table-column>-->


				<el-table-column v-for='(item,index) in tableHeadList' :width="item.width" :prop="item.prop"
					:label="item.label" :key="index">
				</el-table-column>
				<!-- <el-table-column label="状态" prop="ORMTB478CD01">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.ORMTB478CD01=='0'" type="">待审核</el-tag>
						<el-tag v-if="scope.row.ORMTB478CD01=='1'" type="success">通过</el-tag>
						<el-tag v-if="scope.row.ORMTB478CD01=='2'" type="danger">拒绝</el-tag>
					</template>
				</el-table-column> -->



				<el-table-column label="操作" fixed="right" width="300">
					<template slot-scope="scope">
						<!--<el-button class="public_icon_xiangqing public_icon_width  public_icon_margin" type="primary"
								   size="small" @click="DetailsClick(scope.row)">详情</el-button>-->
						<!-- <el-button v-if="uobj.pertb005.pertb005cb00 == 'CUS-2'"  @click="modify(scope.row)"
							class="public_icon_xiugai public_icon_width  public_icon_margin" id="修改" type="primary"
							size="small">修改</el-button> -->
						<el-button @click="ykxqFun(scope.row)"
							class="public_icon_xiangqing public_icon_width  public_icon_margin" id="修改" type="primary"
							size="small">详情</el-button>


						<!-- <el-button type="primary" class="public_icon_xiugai public_icon_width" id="修改" size="small"
							@click="cdjlialClick(scope.row)">油号管理
						</el-button>

						<el-button type="primary" class="public_icon_xiugai public_icon_width" id="修改" size="small"
							@click="cduserClick(scope.row)">新增油号
						</el-button> -->



					</template>
				</el-table-column>
			</el-table>
			<div class="pulbic_pagesize">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="limitMo"
					layout="total,sizes, prev, pager, next" :total="pagingPageMo">
				</el-pagination>
			</div>
		</div>


		<!-- 新增 -->
		<div class="public-dialog">
			<el-dialog title="新增车辆" @close="XAdd" :visible.sync="billOperationAdd" width="40%"
				:closeOnClickModal='false'>
				<div class="systemCodePC-add-code">
					<div class="systemCodePC-add-code-table">
						<!-- <div class="systemCodePC-add-code-table-li">
							<div class="systemCodePC-add-code-table-li-name">油站名称</div>
							<div class="systemCodePC-add-code-table-li-ipt">
								<input type="text" class="car-number-add" :maxlength="maxl" v-model="ORMTB473CA00ADD" />
							</div>
							<div class="systemCodePC-add-code-table-li-text">*必填*</div>
						</div> -->
						<div class="systemCodePC-add-code-table-li">
							<div class="systemCodePC-add-code-table-li-name">车牌号</div>
							<div class="systemCodePC-add-code-table-li-ipt">
								<input type="text" class="car-number-add" :maxlength="maxl" v-model="ORMTB473CA06" />
							</div>
							<div class="systemCodePC-add-code-table-li-text">*必填*</div>
						</div>

						<div class="systemCodePC-add-code-table-li">
							<div class="systemCodePC-add-code-table-li-name">手机号</div>
							<div class="systemCodePC-add-code-table-li-ipt">
								<input type="text" class="car-number-add" :maxlength="maxl" v-model="ORMTB473CA10ADD" />
							</div>
							<div class="systemCodePC-add-code-table-li-text">*必填*</div>
						</div>

					</div>
					<div class="systemCodePC-add-code-btn">
						<el-button type="primary" @click="preservationAdd">保存</el-button>
						<el-button type="warning" @click="cancelAdd">取消</el-button>
					</div>
				</div>
			</el-dialog>
		</div>
		<!-- 修改信息 -->
		<div class="public-dialog">
			<el-dialog title="修改信息" @close="XAdd" :visible.sync="billOperationDetails" width="40%"
				:closeOnClickModal='false'>
				<div class="systemCodePC-add-code">
					<div class="systemCodePC-add-code-table">
						<div class="systemCodePC-add-code-table-li">
							<div class="systemCodePC-add-code-table-li-name">车牌号</div>
							<div class="systemCodePC-add-code-table-li-ipt">
								<input type="text" v-model="modifyObj.SETTB402CA00" />
							</div>
							<div class="systemCodePC-add-code-table-li-text">*必填*</div>
						</div>
						<div class="systemCodePC-add-code-table-li">
							<div class="systemCodePC-add-code-table-li-name">手机号</div>
							<div class="systemCodePC-add-code-table-li-ipt">
								<input type="text" v-model="modifyObj.ORMTB410CA02" />
							</div>
							<div class="systemCodePC-add-code-table-li-text">*必填*</div>
						</div>

					</div>
					·
					<div class="systemCodePC-add-code-btn">
						<el-button type="primary" @click="preservationModify">确定</el-button>
						<el-button type="danger" @click="qxButFun">取消</el-button>
					</div>
				</div>
			</el-dialog>
		</div>


		<div class="public-dialog">
			<el-dialog title="油号信息" :visible.sync="cdsUpdateShow" width="30%" :closeOnClickModal='false'>
				<div class="customerManagementPC-add-customer">
					<div class="customerManagementPC-add-customer-li">
						<div class="customerManagementPC-add-customer-li-name">油号:</div>
						<div class="customerManagementPC-add-customer-li-ipt">
							<input type="text" v-model="cdsUpdateObj.ORMTB475CA01" maxlength="100" />
						</div>
						<div class="customerManagementPC-add-customer-li-type">*必填*</div>
					</div>
					<div class="customerManagementPC-add-customer-li">
						<div class="customerManagementPC-add-customer-li-name">油站价格:</div>
						<div class="customerManagementPC-add-customer-li-ipt">
							<input type="text" v-model="cdsUpdateObj.ORMTB475CA02" maxlength="11" />
						</div>
						<div class="customerManagementPC-add-customer-li-type">*必填*</div>
					</div>

					<div class="customerManagementPC-add-customer-li">
						<div class="customerManagementPC-add-customer-li-name">飞砂走石价格:</div>
						<div class="customerManagementPC-add-customer-li-ipt">
							<input type="text" v-model="cdsUpdateObj.ORMTB475CA03" maxlength="100" />
						</div>
						<div class="customerManagementPC-add-customer-li-type">*必填*</div>
					</div>

					<div class="customerManagementPC-add-customer-li">
						<div class="customerManagementPC-add-customer-li-name">国际油价:</div>
						<div class="customerManagementPC-add-customer-li-ipt">
							<input type="text" v-model="cdsUpdateObj.ORMTB475CA04" maxlength="100" />
						</div>
						<div class="customerManagementPC-add-customer-li-type">*必填*</div>
					</div>


					<div class="customerManagementPC-add-customer-li">
						<div class="customerManagementPC-add-customer-li-name">是否默认:</div>
						<div class="customerManagementPC-add-customer-li-ipt">
							<!--<input type="text" v-model="cdsUpdateObj.SETTB411CA03" maxlength="100" />-->

							<template>
								<el-radio v-model="cdsUpdateObj.ORMTB475CA05" label="0">不默认</el-radio>
								<el-radio v-model="cdsUpdateObj.ORMTB475CA05" label="1">默认</el-radio>
							</template>

						</div>
						<div class="customerManagementPC-add-customer-li-type">*必填*</div>
					</div>

					<div class="customerManagementPC-add-customer-btn">
						<el-button type="primary" @click="cdsUpdateServe">保存</el-button>
						<el-button type="info" @click="cdsUpdateShow=false">取消</el-button>
					</div>
				</div>
			</el-dialog>
		</div>

		<div class="public-dialog">
			<el-dialog title="新增车辆记录" :visible.sync="cdleWaterDetails" width="60%" :closeOnClickModal='false'>
				<div class="pulbic_oparetionBlock" style="margin:0;padding-top: 1vw;">
					<div class="public_criteriaRange">
						<div class="public_oparetionBlock_Menu">
							<label class="public_lbSty">手机号：</label>
							<div class="el-select public_optionSty">
								<div class="el-input el-input--suffix">
									<input class="pulic_carNumber" type="text" placeholder="请输入客户手机号" v-model="phone" />
								</div>
							</div>
						</div>
						
						<div class="public_operatBtn" style="margin-left: 20px;">
							<button @click="queryCarClick" class="public_saleWater_chaxun pulic_cursor" id="查询"><i
									class="iconfont icon-chaxun"></i>查询</button>
						
							<!-- <button @click="exports" class="public_saleWater_daochu pulic_cursor"     id="导出"><i class="iconfont icon-daochu"></i>导出</button> -->
						</div>

					</div>
				</div>

				<div class="salesWatersStatisticsPC-saleWaterDetails">
					<div class="salesWatersStatisticsPC-saleWaterDetails-table pulbic_table_container">
						<el-table :data="cdtableDataDetails" style="width: 100%" stripe class="public_tableColumn"
							:header-cell-style="{'font-family':'Microsoft YaHei','font-weight':'bold',color:'rgba(51,51,51,1)'}">
							<el-table-column prop="SETTB402CA00" label="车牌号">
							</el-table-column>
							<el-table-column prop="ORMTB410CA00" label="姓名">
							</el-table-column>
							<el-table-column prop="ORMTB410CA02" label="手机号">
							</el-table-column>
							<el-table-column label="操作" width="300">
								<template slot-scope="scope">
									<el-button v-if="uobj.pertb005.pertb005cb00 == 'CUS-2'"  @click="modify(scope.row)"
										class="public_icon_xiugai public_icon_width  public_icon_margin" id="修改" type="primary"
										size="small">修改</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="billOperationRecord-page">
						<el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2"
							:current-page.sync="currentPage2" :page-sizes="[10, 20, 30, 40]"
							:page-size="detailsPageLimit2" layout="total,sizes, prev, pager, next"
							:total="detailsCount2">
						</el-pagination>
					</div>
				</div>
			</el-dialog>
		</div>

		<!-- 油号修改 -->
		<div class="public-dialog">
			<el-dialog title="油号修改" :visible.sync="rechargeTypeModifyDig" width="30%" @close="rechargeTypeModifyClose"
				:closeOnClickModal='false'>
				<div class="customerManagementPC-add-customer">

					<div class="customerManagementPC-add-customer-li">
						<div class="customerManagementPC-add-customer-li-name">油号:</div>
						<div class="customerManagementPC-add-customer-li-ipt">
							<input type="text" v-model="rechargeTypeUpOBJ.ORMTB475CA01" maxlength="100" />
						</div>
						<div class="customerManagementPC-add-customer-li-type">*必填*</div>
					</div>
					<div class="customerManagementPC-add-customer-li">
						<div class="customerManagementPC-add-customer-li-name">油站价格:</div>
						<div class="customerManagementPC-add-customer-li-ipt">
							<input type="text" v-model="rechargeTypeUpOBJ.ORMTB475CA02" maxlength="11" />
						</div>
						<div class="customerManagementPC-add-customer-li-type">*必填*</div>
					</div>

					<div class="customerManagementPC-add-customer-li">
						<div class="customerManagementPC-add-customer-li-name">飞砂走石价格:</div>
						<div class="customerManagementPC-add-customer-li-ipt">
							<input type="text" v-model="rechargeTypeUpOBJ.ORMTB475CA03" maxlength="100" />
						</div>
						<div class="customerManagementPC-add-customer-li-type">*必填*</div>
					</div>

					<div class="customerManagementPC-add-customer-li">
						<div class="customerManagementPC-add-customer-li-name">国际油价:</div>
						<div class="customerManagementPC-add-customer-li-ipt">
							<input type="text" v-model="rechargeTypeUpOBJ.ORMTB475CA04" maxlength="100" />
						</div>
						<div class="customerManagementPC-add-customer-li-type">*必填*</div>
					</div>


					<div class="customerManagementPC-add-customer-li">
						<div class="customerManagementPC-add-customer-li-name">是否默认:</div>
						<div class="customerManagementPC-add-customer-li-ipt">
							<template>
								<el-radio-group v-model="rechargeTypeUpOBJ.ORMTB475CA05">
									<el-radio :label="0">不默认</el-radio>
									<el-radio :label="1">默认</el-radio>
								</el-radio-group>
							</template>

						</div>
						<div class="customerManagementPC-add-customer-li-type">*必填*</div>
					</div>


					<div class="customerManagementPC-add-customer-btn">
						<el-button type="primary" @click="rechaTypePreserModify">保存</el-button>
						<el-button type="info" @click="rechargeTypeModifyDig=false">取消</el-button>
					</div>
				</div>

			</el-dialog>
		</div>



	</div>
</template>

<script>
	import debounce from '../../api/debounce';
	// import Map from '../sales/salesBigCustomers/aliMap.vue'
	export default {
		// components: {
		// 	Map
		// },
		data() {
			return {

				inputVisible: false,
				inputValue: '',
				inputVisible2: false,
				inputValue2: '',


				formdata: new FormData(),

				loadingBut: false,
				confirmTxt: 0,
				isorderAuditText: '',
				oerderDetilsShow: false,
				orderAuditShow: false,
				isorderAuditShow: false,
				returnReceiptShow: false,
				uobj: this.$store.state.uobj, //登陆缓存--用户信息
				date: [], //日期
				startTime: '',
				endTime: '',
				dateNowDayActive: false,
				dateYesterdayActive: false,
				dateNowMonthActive: false,
				dateLastMonthActive: false,
				twolevelUserLogin: true,
				timeIndex: 0, //判断第几次切换当月时间
				sameMonthTime: '', //目前月份
				currentMonthTime: '', //目前月份--上月+1
				tableData: [],
				ORMTB440CA00: '',
				materialOptions: [],
				materialTypeValue: '',
				oilList: [{
					ORMTB473ID: '',
					ORMTB473CA00: '全部',
				}],
				carNum: '',
				materielMo: '',
				materielOptions: [{
						value: '',
						label: '全部',
					},
					{
						value: '0',
						label: '待审核'
					},
					{
						value: '1',
						label: '通过'
					},
					{
						value: '2',
						label: '拒绝'
					}

				],

				maxl: 100,
				// 查询
				ORMTB473CA00: '', //加油站



				currentPage2: 1,
				detailsPageLimit2: 10,
				detailsCount2: 1,
				cdtableDataDetails: [],
				cdsUpdateShow: false,
				cdsUpdateObj: {
					ORMTB475ID: '',
					ORMTB475CA00: '',
					ORMTB475CA01: '',
					ORMTB475CA02: '',
					ORMTB475CA03: '',
					ORMTB475CA04: '',
					ORMTB475CA05: ''
				},
				cdleWaterDetails: false,
				rechargeTypeUpOBJ: {},
				rechargeTypeModifyDig: false,
				phone:'',
				// 新增
				edCarNameModify: '',
				ORMTB473CA05ADD: '',
				ORMTB473CA00ADD: '',
				ORMTB473CA01ADD: '',
				ORMTB473CA02ADD: '',
				ORMTB473CA02ADD: '',
				ORMTB473CA03ADD: '',
				ORMTB473CA04ADD: '',
				ORMTB473CA06ADD: '',
				ORMTB473CA08ADD: '',
				ORMTB473CA10ADD: '',
				ORMTB473CA09ADD: [],
				ORMTB473CA09: '',
				ORMTB473CA06: '',


				ORMTB540CA04: '',
				ORMTB540CA05: '',

				modifyObj: {},

				//dialog
				billOperationAdd: false,
				billOperationDetails: false,
				billXQOperationDetails: false,

				pageMo: 1, //默认列表页码
				limitMo: 10, //每页的条数
				pagingPageMo: 0, //分页--数据列表共有的条数
				currentPage: 1, //设置当前页默认为1
				// 详情
				detailsList: '', //详情列表
				tableHeadList: [

					// {
					// 	prop: 'ORMTB478CB01',
					// 	label: '申请时间',

					// },

					{
						prop: 'SETTB402CA00',
						label: '车牌号',

					},
					{
						prop: 'ORMTB410CA00',
						label: '姓名',

					},
					{
						prop: 'ORMTB410CA02',
						label: '手机',

					}
					// {
					// 	prop: 'ORMTB478CA01',
					// 	label: '申请金额',

					// }
					// {
					// 	prop: 'ORMTB473CA03',
					// 	label: '飞砂走石价格',

					// }
					// {
					// 	prop: 'ORMTB473CA04',
					// 	label: '经度',

					// },
					// {
					// 	prop: 'ORMTB473CA05',
					// 	label: '维度',

					// },

				],

				isRefresh: true,
				// 历史缓存
				currentUrl: this.$route.path,
				historyInfo: '',
				// 时间限制
				// 限制开始日期不能超过当前日期
				startDateDisabled: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					}
				},
				pageMaterial: 1, //默认列表页码
				limitMaterial: 10, //每页的条数
				pagingPageMaterial: 0, //分页--数据列表共有的条数
				currentPageMaterial: 1, //设置当前页默认为1
				solelist: [],
				DetailsWaterurl: '',
				DetailsWatersrcList: [],
				DetailsWeightrcList: [],
				DetailsWeightrcBDList: [],
				ewmDetails: [],
				materialList: [],
				materialValue: '',
				listTick: null, // 列表刷新定时器
				timeType: '1',
				distf: true,
				mapPopUp: '',
				DetailsWater: false,
				psAdres: '',
				psxxAdres: '',
				objOpiData: {},
				longitude: '',
				latitude: '',
				dcmoreID: '',
				dcmore: '',
				modifyObj:{}
			}
		},
		watch: {
			weightOpt: {
				handler(val) {
					if ((val.tare || val.tare === 0) && (val.gross || val.gross === 0) && (val.price || val.price === 0)) {
						let tare = parseFloat(val.tare)
						let gross = parseFloat(val.gross)
						this.detailsList.ORMTB440CC04 = (tare - gross).toFixed(2)
						if (this.detailsList.ORMTB440CC04) {
							debounce(this.getSettlementAmount, 500)
						}
					} else {
						this.detailsList.ORMTB440CC04 = ''
						this.detailsList.ORMTB440CC06 = ''
					}
				},
				deep: true
			},
		},
		created() {
			var list = "";
			list = this.$store.state.solelist;
			console.log(list)
			// 赋值，缓存销毁
			this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))
			sessionStorage.removeItem(this.currentUrl)
			if (this.historyInfo != null && this.historyInfo != '') {
				this.init()
			}
			console.log(this.historyInfo)
			var path = this.$route.path;
			if (path === '/CRMCarAdmin') {
				path = '/Home' + path
			}
			this.solelist = this.$baseAPI.querSoleList(list, path); //获取权限列表
			console.log(this.solelist)
		},
		mounted() {
			if (this.historyInfo == null && this.$route.query.mark == null) {
				this.getNowDay();
				this.startTime = this.date[0];
				this.endTime = this.date[1];
				this.dateNowDayActive = true
			}

			this.pageList()
			this.listTick = setInterval(() => {
				this.queryClick()
			}, 1000 * 60)

		},
		// 存储数据
		beforeDestroy() {
			clearInterval(this.listTick)
			this.listTick = null
			var obj = {
				ORMTB400CA03: this.ORMTB400CA03, //客户名称
				ORMTB440CA04: this.ORMTB440CA04, //客户名称
				currentPage: this.currentPage, //当前页数
				pageMo: this.pageMo, //页码
				limitMo: this.limitMo, //每页条数
				ORMTB440CA00: this.ORMTB440CA00
			}
			sessionStorage.setItem(this.currentUrl, JSON.stringify(obj))
		},
		methods: {

			clearFun() {
				this.materielMo = ''
			},

			handleSizeChangeMaterial(val) {
				this.pageMaterial = 1
				this.limitMaterial = val;
				this.pageMaterialList();
			},
			// 点击页码
			handleCurrentChangeMaterial(val) {
				this.pageMaterial = val;
				this.pageMaterialList();
			},

			handleClose(tag) {
				this.ORMTB473CA09ADD.splice(this.ORMTB473CA09ADD.indexOf(tag), 1);
			},

			showInput() {
				this.inputVisible = true;
				this.$nextTick(_ => {
					this.$refs.saveTagInput.$refs.input.focus();
				});
			},

			handleInputConfirm() {
				let inputValue = this.inputValue;
				if (inputValue) {
					this.ORMTB473CA09ADD.push(inputValue);
				}
				this.inputVisible = false;
				this.inputValue = '';
			},

			handleClose2(tag) {
				this.ORMTB473CA09UP.splice(this.ORMTB473CA09UP.indexOf(tag), 1);
			},

			showInput2() {
				this.inputVisible2 = true;
				this.$nextTick(_ => {
					this.$refs.saveTagInput.$refs.input.focus();
				});
			},
			adresOpiFun() {
				this.DetailsWater = true
			},
			updateLocation(Addr) {
				// console.log('位置信息：', Addr)
				this.objOpiData = Addr
			},
			subOpiFun() {
				this.DetailsWater = false
				if (this.mapPopUp == 0) {
					this.ORMTB473CA01ADD = this.objOpiData.orgAddr
					this.psxxAdres = this.objOpiData.address
					this.ORMTB473CA04ADD = this.objOpiData.lon
					this.ORMTB473CA05ADD = this.objOpiData.lat
				}
				if (this.mapPopUp == 1) {
					this.modifyObj.ORMTB473CA01 = this.objOpiData.orgAddr //地址
					this.modifyObj.ORMTB473CA11 = this.objOpiData.address //详细地址
					this.modifyObj.ORMTB473CA04 = this.objOpiData.lon //经度
					this.modifyObj.ORMTB473CA05 = this.objOpiData.lat //纬度
				}

			},
			rechargeTypeModifyClose() {

			},

			handleInputConfirm2() {
				let inputValue2 = this.inputValue2;
				if (inputValue2) {
					this.ORMTB473CA09UP.push(inputValue2);
				}
				this.inputVisible2 = false;
				this.inputValue2 = '';
			},


			//初始化数据
			init() {
				this.startTime = this.historyInfo.startTime
				this.endTime = this.historyInfo.endTime
				this.date = [this.startTime, this.endTime]
				this.ORMTB400CA03 = this.historyInfo.ORMTB400CA03
				this.ORMTB440CA06 = this.historyInfo.ORMTB440CA06
				this.ORMTB440CF01 = this.historyInfo.ORMTB440CF01
				this.ORMTB440CA00 = this.historyInfo.ORMTB440CA00
				this.ORMTB440CA01 = this.historyInfo.ORMTB440CA01
				this.currentPage = this.historyInfo.currentPage
				this.pageMo = this.historyInfo.pageMo
				this.limitMo = this.historyInfo.limitMo
				this.dateNowDayActive = this.historyInfo.dateNowDayActive
				this.dateYesterdayActive = this.historyInfo.dateYesterdayActive
				this.dateNowMonthActive = this.historyInfo.dateNowMonthActive
				this.dateLastMonthActive = this.historyInfo.dateLastMonthActive
				this.ORMTB440CA00 = this.historyInfo.ORMTB440CA00
			},
			// 导出
			// 查询
			queryClick() {
				this.pageMo = 1
				this.pageList()
			},
			queryCarClick() {
				this.currentPage2 = 1
				this.queryCdWayTypeQuery()
			},
			// 新增取消--X
			XAdd() {
				// this.materielIndex = 0;
			},
			// 新增
			newlyAdd() {
				this.billOperationAdd = true;
				this.mapPopUp = 0 //新增
				this.ORMTB473CA05ADD = ''
				this.ORMTB473CA00ADD = ''
				this.ORMTB473CA01ADD = ''
				this.psxxAdres = ''
				this.ORMTB473CA03ADD = ''
				this.ORMTB473CA04ADD = ''
				this.ORMTB473CA06 = ''
				this.ORMTB473CA08ADD = ''
				this.ORMTB473CA09 = ''
				this.ORMTB473CA10ADD = ''
			},
			preservationAdd() {
				if (this.ORMTB473CA06 == '') {
					this.$message({
						message: "请输入车牌号",
						type: 'error'
					});
					return
				}
				if (this.ORMTB473CA10ADD == '') {
					this.$message({
						message: "请输入手机号",
						type: 'error'
					});
					return
				}
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});


				var postData = {
					ORMTB410CA02: this.ORMTB473CA10ADD, //手机号
					SETTB402CA00: this.ORMTB473CA06 //车牌号
				}
				var url = "/set/settb402/insertForDriver";
				this.axios.post(url, postData).then(res => {
					if (res.data.code == 200) {
						this.billOperationAdd = false;
						this.$message({
							message: '新增成功',
							type: 'success'
						});
						this.pageList();

					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close();
				})
			},
			cancelAdd() {
				this.billOperationAdd = false;
			},
			preservationModify() {
				console.log(this.modifyObj.ORMTB478CA01)
				if (this.modifyObj.SETTB402CA00 == '') {
					this.$message({
						message: "请输入车牌号",
						type: 'error'
					});
					return
				}
				
				if (this.modifyObj.ORMTB410CA02 == '') {
					this.$message({
						message: "请输入手机号",
						type: 'error'
					});
					return
				}

				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});

				var postData = {
					ORMTB418ID: this.modifyObj.ORMTB418ID, //ID
					SETTB402CA00: this.modifyObj.SETTB402CA00, 
					ORMTB410CA02: this.modifyObj.ORMTB410CA02, 
				}
				var url = "/set/settb402/updateForDriver";
				this.axios.post(url, postData).then(res => {
					if (res.data.code == 200) {
						this.billOperationDetails = false;
						this.$message({
							message: '成功',
							type: 'success'
						});
						this.pageList();

					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close();
				})
			},
			qxButFun() {
				this.billOperationDetails = false;
				this.modifyObj.ORMTB478CA01 = ''
			},

			exports() {
				// console.log(this.uobj)
				if (this.uobj.pertb005.pertb005cb00 == "CUS-2") {
					this.ORMTB474CA00 = this.uobj.ormtb410.ORMTB410ID //一级企业id

				}
				var startTime = this.date[0]; //开始时间
				var endTime = this.date[1]; //结束时间
				var ORMTB440CA02 = this.ORMTB474CA00; //二级客户ID
				var ORMTB400CA03 = 1002; //一级客户代码
				var ORMTB440CA04 = this.enterpriseTwo; //二级企业ID
				var ORMTB440CA06 = this.materielMo; //物料ID
				var ORMTB440CA00 = this.ORMTB440CA00; //订单号
				var ORMTB440CA01 = this.carNumber; //车牌号
				var timeType = this.timeType; //
				var url = this.axios.defaults.baseURL + "/exc/toExcel/ormtb440toExcle?startTime=" + startTime +
					"&endTime=" +
					endTime + "&ORMTB440CA02=" + ORMTB440CA02 + "&ORMTB400CA03=" + ORMTB400CA03 +
					"&ORMTB440CA04=" + ORMTB440CA04 + "&ORMTB440CA06=" + ORMTB440CA06 + "&ORMTB440CF01=" +
					ORMTB440CF01 + "&ORMTB440CA00=" + ORMTB440CA00 + "&ORMTB440CA01=" + ORMTB440CA01 + "&timeType=" +
					timeType;
				window.location.href = url;

				this.loadingBut = true
				var timer = null //倒计时
				this.confirmTxt = 30 - 1
				timer = setInterval(() => {
					if (this.confirmTxt === 0) {
						this.confirmTxt = ""
						this.loadingBut = false
						clearInterval(timer);
					} else {
						this.confirmTxt--
					}
				}, 1000);

			},


			// 取消订单
			cancelOrder(row) {
				var url = "/orm/ormtb440/updateORMTB440CF01";
				this.$prompt('请输入取消原因', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputPattern: /^.{1,}$/,
					inputErrorMessage: '原因不能为空'
				}).then(({
					value
				}) => {
					var postData = {
						ORMTB440ID: row.ORMTB440ID,
						ORMTB440CF01: -1, //状态
						ORMTB440CD01: value, //取消原因
					}
					let loading = this.$loading({
						lock: true,
						text: '请求中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.5)'
					});
					this.axios.post(url, postData).then(res => {
						if (res.data.code == 200) {
							this.pageList()
							this.$message({
								type: 'success',
								message: '取消成功!'
							});
						} else {
							this.$message({
								message: res.data.message,
								type: 'error'
							});
						}
						loading.close();
					}).catch(() => {
						loading.close();
					})
				})
			},
			// ch

			// 查询
			queryClick() {
				this.startTime = this.date[0];
				this.endTime = this.date[1];
				this.pageList()
			},
			// 列表
			pageList() {
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					// startTime: this.startTime, //开始时间
					// endTime: this.endTime, //结束时间
					// ORMTB410CA02: this.ORMTB540CA04,
					SETTB402CA00: this.ORMTB540CA04,
					// ORMTB478CD01: this.materielMo,
					page: this.pageMo,
					limit: this.limitMo
				}
				this.tableData = [];
				var url = "/set/settb402/selectPageListCus2";
				this.axios.post(url, postData).then(res => {
					setTimeout(() => {
						loading.close()
					}, 400)
					// console.log(res)
					if (res.data.code == 200) {
						console.log(res)
						var data = res.data.data;
						console.log(data)
						this.pagingPageMo = res.data.count;
						// for (var i = 0; i < data.length; i++) {
						// 	var customerName = "";

						// 	data[i]['msgFlag'] = 0
						// 	// if (data[i]['ORMTB440CA32'] != null) {
						// 	// 	try {
						// 	// 		let dataJs = JSON.parse(data[i]['ORMTB440CA32']);
						// 	// 		data[i]['msgFlag'] = dataJs.errcode
						// 	// 	} catch {
						// 	// 		console.log(data[i]['ORMTB440CA32'])
						// 	// 		data[i]['msgFlag'] = 1
						// 	// 	}
						// 	// }
						// }
						this.tableData = data;

					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},
			// 详情
			DetailsClick(row) {
				this.oerderDetilsShow = true;
				this.querydetile(row)
			},

			modify(row) {
				this.billOperationDetails = true;
				this.modifyObj = row
				console.log(this.modifyObj)
				// this.mapPopUp = 1 //修改
				// this.ORMTB473IDUP = row['ORMTB473ID']
				// this.ORMTB473CA05UP = row['ORMTB473CA05']
				// this.ORMTB473CA00UP = row['ORMTB473CA00']
				// this.ORMTB473CA01UP = row['ORMTB473CA01']
				// this.ORMTB473CA02UP = row['ORMTB473CA02']
				// this.ORMTB473CA02UP = row['ORMTB473CA02']
				// this.ORMTB473CA03UP = row['ORMTB473CA03']
				// this.ORMTB473CA04UP = row['ORMTB473CA04']
				// this.ORMTB473CA08UP = row['ORMTB473CA08']
				// this.ORMTB473CA06UP = row['ORMTB473CA06']
				// this.ORMTB473CA06UP = row['ORMTB473CA06']
				// this.ORMTB473CA011UP = row['ORMTB473CA11']

				// this.ORMTB473CA09UP = [];
				// console.log(JSON.parse(row['ORMTB473CA09']))
				// JSON.parse(row['ORMTB473CA09']).forEach(resitem => {
				// 	this.ORMTB473CA09UP.push(resitem.text)
				// })
				// // this.ORMTB473CA09UP = row['ORMTB473CA09'].split(",")
				// this.ORMTB473CA10UP = row['ORMTB473CA10']

			},
			ykxqFun(row) {
				this.cdleWaterDetails = true
				this.modifyObj = row
				this.queryCdWayTypeQuery()
			},

			// cduserClick(row) {
			// 	this.cdsUpdateShow = true
			// 	// this.cdsUpdateObj.ORMTB410ID = row.ORMTB473ID
			// 	this.cdsUpdateObj.ORMTB475CA00 = row.ORMTB473ID
			// 	this.cdsUpdateObj.ORMTB475CA01 = row.ORMTB410CA00
			// 	this.cdsUpdateObj.ORMTB475CA02 = row.ORMTB410CA02
			// 	// this.cdsUpdateObj.SETTB411CA03 = '0'
			// },

			cdjlialClick(row) {
				this.cdleWaterDetails = true
				this.cdsUpdateObj.ORMTB475CA00 = row.ORMTB473ID
				this.queryCdWayTypeQuery()
			},
			queryCdWayTypeQuery() {
				this.cdtableDataDetails = []
				// this.detailsCount=0
				var url = "/set/settb402/detailForDriver"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB410CA02: this.phone,
					SETTB402ID: this.modifyObj.SETTB402ID,
					page: this.currentPage2,
					limit: this.detailsPageLimit2
				}
				this.axios.post(url, postData).then(res => {
					if (res.data.code == 200) {
						console.log(res)
						this.cdtableDataDetails = res.data.data;
						this.detailsCount2 = res.data.count
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			handleSizeChange2(val) {
				this.detailsPageLimit2 = val;
				this.currentPage2 = 1;
				// this.deductionRecordClick();
				this.queryWayTypeQuery()
			},
			handleCurrentChange2(val) {
				this.currentPage2 = val;
				// this.deductionRecordClick();
				this.queryCdWayTypeQuery()
			},

			cdsUpdateServe() {
				// if(!this.cdsUpdateObj.SETTB411CA03){
				//     this.$message.error('请选择是否冲抵')
				//     return;
				// }
				// if(!this.cdsUpdateObj.SETTB411CA04){
				//     this.$message.error('请输入金额')
				//     return;
				// }
				var url = "/orm/ormtb475/add"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = this.cdsUpdateObj
				this.axios.post(url, postData).then(res => {
					if (res.data.code == 200) {
						this.$message.success('成功')
						// this.querycusList()
						this.cdsUpdateShow = false
						this.cdsUpdateObj = {
							ORMTB475ID: '',
							ORMTB475CA00: '',
							ORMTB475CA01: '',
							ORMTB475CA02: '',
							ORMTB475CA03: '',
							ORMTB475CA04: '',
							ORMTB475CA05: ''
						}
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			rechargeTypeModify(row) {
				this.rechargeTypeModifyDig = true
				var str = JSON.stringify(row)
				this.rechargeTypeUpOBJ = JSON.parse(str)
				console.log(this.rechargeTypeUpOBJ)
			},
			deleteClick(row) {
				var postData = {
					ORMTB475ID: row.ORMTB475ID, //流水id
				}
				var url = "/orm/ormtb475/delete";
				this.$confirm('此操作将删除该记录, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.axios.post(url, postData).then(res => {
						// console.log(res)
						if (res.data.code == 200) {
							this.queryCdWayTypeQuery()
							this.$message({
								type: 'success',
								message: '操作成功!'
							});
						} else {
							this.$message({
								message: res.data.message,
								type: 'error'
							});
						}
					})
				})
			},
			rechaTypePreserModify() {
				var url = "/orm/ormtb475/update"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = this.rechargeTypeUpOBJ
				this.axios.post(url, postData).then(res => {
					if (res.data.code == 200) {
						this.$message.success('修改成功')
						this.queryCdWayTypeQuery()
						this.rechargeTypeModifyDig = false

						this.rechargeTypeUpOBJ = {}

					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})


			},

			orderAudit(row) {
				this.orderAuditShow = true
				this.querydetile(row)
			},
			isorderAudit(row) {
				this.isorderAuditShow = true
				this.querydetile(row)
			},
			returnReceipt(row) {
				this.returnReceiptShow = true
				this.querydetile(row)
			},


			querydetile(row) {
				var postData = {
					ORMTB440ID: row.ORMTB440ID, //流水id
				}
				this.detailsList = ''
				var url = "/orm/ormtb440/selectDetails";
				this.axios.post(url, postData).then(res => {
					if (res.data.code == 200) {
						this.detailsList = res.data.data;
						this.DetailsWatersrcList = [this.detailsList.ORMTB440CE01]
						if (this.detailsList.ORMTB440CH05) this.DetailsWeightrcList = [this.detailsList
							.ORMTB440CH05
						]
						if (this.detailsList.ORMTB440CL01) this.DetailsWeightrcBDList = [this.detailsList
							.ORMTB440CL01
						]
						this.DetailsWaterurl = this.detailsList.ORMTB440CE01
						if (this.detailsList.ORMTB440CF01 == 6 || (row.ORMTB440CF01 == 0 && row.ORMTB440CA22)) {
							this.weightOpt.price = this.detailsList.ORMTB440CC03
							if (this.detailsList.ORMTB440CC06 == 0) this.detailsList.ORMTB440CC06 = ''
							this.weightOpt.tare = this.detailsList.ORMTB440CC05
							this.weightOpt.gross = (this.detailsList.ORMTB440CC05 - this.detailsList.ORMTB440CC04)
								.toFixed(2)
							this.getSelectMaterial()
						}
						// else if (this.detailsList.ORMTB440CF01 == 0) {
						// 	this.weightOpt.price = this.detailsList.ORMTB440CC03
						// 	this.getSelectMaterial()
						// }

					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}

				})
			},
			queryermdetile(row) {
				var postData = {
					ORMTB440ID: row.ORMTB440ID, //流水id
				}
				this.detailsList = ''
				var url = "/orm/ormtb440/getErwei";
				this.axios.post(url, postData).then(res => {
					if (res.data.code == 200) {
						this.ewmdetailsList = res.data.data;
						this.ewmdetailsList.ORMTB440CA22Img = 'data:image/png;base64,' + res.data.data
							.ORMTB440CA22;

					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}

				})
			},

			dateFtt(fmt, date) { //author: meizz
				var o = {
					"M+": date.getMonth() + 1, //月份
					"d+": date.getDate(), //日
					"h+": date.getHours(), //小时
					"m+": date.getMinutes(), //分
					"s+": date.getSeconds(), //秒
					"q+": Math.floor((date.getMonth() + 3) / 3), //季度
					"S": date.getMilliseconds() //毫秒
				};
				if (/(y+)/.test(fmt))
					fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
				for (var k in o)
					if (new RegExp("(" + k + ")").test(fmt))
						fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k])
							.length)));
				return fmt;
			},

			//获取当前时间
			getNowDay() {
				var date = new Date().getTime();
				var Ming = new Date().getTime() + 24 * 60 * 60 * 1000;
				var data = this.dateFtt('yyyy-MM-dd', new Date(Ming))
				var enddata = this.dateFtt('yyyy-MM-dd', new Date(date))
				data = `${data} ${this.exchangeTiem||'00:00:00'}`
				enddata = `${enddata} ${this.exchangeTiem||'00:00:00'}`
				this.date = [enddata, data];
				this.dateNowDayActive = true
				this.dateYesterdayActive = false
				this.dateNowMonthActive = false
				this.dateLastMonthActive = false
			},
			datePickerChange(e) {
				this.dateNowDayActive = false
				this.dateYesterdayActive = false
				this.dateNowMonthActive = false
				this.dateLastMonthActive = false
			},
			//获取昨天时间
			getYesterday() {
				var hms = new Date().getTime() - 24 * 60 * 60 * 1000;
				var Ming = new Date().getTime();
				var nowDay = this.dateFtt('yyyy-MM-dd', new Date(hms))
				var enddata = this.dateFtt('yyyy-MM-dd', new Date(Ming))
				nowDay = `${nowDay} ${this.exchangeTiem||'00:00:00'}`
				enddata = `${enddata} ${this.exchangeTiem||'00:00:00'}`
				this.date = [nowDay, enddata];
				this.dateNowDayActive = false
				this.dateYesterdayActive = true
				this.dateNowMonthActive = false
				this.dateLastMonthActive = false
			},
			//获取当月时间
			sameMonth() {
				var date = new Date();
				var hms = date.setDate(1);
				var firstDay = this.dateFtt('yyyy-MM-dd', new Date(hms));
				firstDay = `${firstDay} ${this.exchangeTiem||'00:00:00'}`
				var nextdate = new Date().getTime() + 24 * 60 * 60 * 1000;
				var nextDay = this.dateFtt('yyyy-MM-dd', new Date(nextdate));
				nextDay = `${nextDay} ${this.exchangeTiem||'00:00:00'}`
				this.date = [firstDay, nextDay];
				this.startTime = this.date[0];
				this.endTime = this.date[1];
				this.dateNowDayActive = false
				this.dateYesterdayActive = false
				this.dateNowMonthActive = true
				this.dateLastMonthActive = false
			},
			//获取上月时间
			lastMonth() {
				var nowdays = new Date();
				var year = nowdays.getFullYear();
				var month = nowdays.getMonth();
				var lastyear = year
				var lastmonth = month
				if (month == 0) {
					month = 12;
					year = year - 1;
				}
				if (month == 12) {
					lastmonth = 1
				} else {
					lastmonth = lastmonth + (1 * 1)
				}
				if (month < 10) {
					month = "0" + month;
				}
				if (lastmonth < 10) {
					lastmonth = "0" + lastmonth;
				}
				var firstDayOfPreMonth = year + "-" + month + "-" + "01";
				var firstDayOfPreMonth = `${year}-${month}-01 ${this.exchangeTiem||'00:00:00'}`;
				// var lastDay = new Date(lastyear, lastmonth, 0);
				let lastDayOfPreMonth = `${lastyear}-${lastmonth}-01 ${this.exchangeTiem||'00:00:00'}`;
				this.date = [firstDayOfPreMonth, lastDayOfPreMonth];
				this.dateNowDayActive = false
				this.dateYesterdayActive = false
				this.dateNowMonthActive = false
				this.dateLastMonthActive = true
			},
			handleSizeChange(val) {
				this.pageMo = 1
				this.limitMo = val;
				this.pageList();
			},
			// 点击页码
			handleCurrentChange(val) {
				this.pageMo = val;
				this.pageList();
			},
		}
	}
</script>

<style scoped>
	.CustomerfillingDig-tab {
		padding-left: 20px;
	}

	.CustomerfillingDig-tab-li,
	.rechargeType-tab-li {
		display: flex;
		height: 50px;
		line-height: 50px;
		text-align: center;
		font-size: 16px;
		color: #333;
		vertical-align: top;
	}

	.CustomerfillingDig-tab-li>div {
		border: 1px solid #CDCDCD;
		border-top: none;
	}

	.CustomerfillingDig-tab-li>div:first-child {
		border-right: none;
	}

	.CustomerfillingDig-tab-li:first-child>div {
		border-top: 1px solid #CDCDCD;
	}

	.CustomerfillingDig-tab-li>div:last-child,
	.rechargeType-tab-li>div:last-child {
		border: none;
		color: #FF4D35;
	}

	.CustomerfillingDig-tab-li-text {
		flex: .8;
		background: rgba(240, 252, 255, 1);
	}

	.CustomerfillingDig-tab-li-ipt {
		flex: .8;
	}

	.rechargeType-tab-li-text {
		flex: .35;
	}

	.rechargeType-tab-li-ipt {
		flex: .7;
	}

	.CustomerfillingDig-tab-li-ipt input,
	.rechargeType-tab-li-ipt input {
		height: 46px;
		width: 100%;

		text-align: center;

		box-sizing: border-box;
		font-size: 16px;
		color: #333;
	}

	.CustomerfillingDig-tab-li-ipt input {
		outline: none;
		border: none;
		vertical-align: top;
	}

	.rechargeType-tab-li-ipt input {
		/* border-radius: 8px; */
		/* outline: none; */
	}

	.CustomerfillingDig-tab-li-b,
	.rechargeType-tab-li-b {
		flex: .3;
	}

	.CustomerfillingDig-tab-btn {
		text-align: center;
		margin-top: 30px;
	}

	.DWD-li {
		display: flex;
		height: 35px;
		line-height: 35px;
		box-sizing: border-box;
		border: 1px solid #999;
		font-size: 16px;
		color: #333;
	}

	.DWD-li>div {
		padding: 0 5px;
		height: 34px;
		overflow: hidden;
		box-sizing: border-box;
	}

	.DWD-li-title {
		width: 120px;
		text-align: center;
		border-right: 1px solid #999;
		background-color: rgba(0, 163, 255, .1);
	}

	.DWD-li-text {
		flex: 1;
	}

	.DWD-li-text input {
		width: 100%;
		height: 35px;
		line-height: 35px;
		border: none;
		outline: none;
	}

	.DWD-li+.DWD-li {
		border-top: none;
	}

	.DWD-table {
		display: flex;
	}

	.DWD-table-left-flex {
		flex: 1;
	}

	.DWD-table>div>div {
		padding: 0 5px;
		height: 35px;
		line-height: 35px;
		overflow: hidden;
		text-align: center;
		border-right: 1px solid #999;
		border-bottom: 1px solid #999;
		box-sizing: border-box;
	}

	.DWD-table>div>div:first-child {
		background-color: rgba(0, 163, 255, .1);
	}

	.DWD-table-left-title>div {
		width: 101px;
		text-align: center;
		background-color: rgba(0, 163, 255, .1);
	}

	.DWD-table .DWD-table-left-title>div {
		padding: 0 5px;
		height: 35px;
		line-height: 35px;
		overflow: hidden;
		box-sizing: border-box;
		border-left: 1px solid #999;
		border-bottom: 1px solid #999;
	}

	.DetailsWater-img {
		margin-top: 30px;
	}

	.DetailsWater-img-text {
		display: inline-block;
		width: 101px;
		text-align: center;
		vertical-align: top;
	}

	.car-number-add {
		/* text-transform: uppercase; */
	}

	.billOperationRecord-table {
		padding: 30px 20px 0;
	}

	.public_singleMenu .pulic_carNumber {
		margin-top: 6px;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		font-size: 14px;
		display: inline-block;
	}

	.pulic_operatArea_now:hover,
	.public_operatArea_yesterday:hover {
		background-color: #ccc;
	}

	/* 新增--列表宽度 */
	.billOperationRecord .systemCodePC-add-code-table-li-ipt {
		flex: 1.5;
	}

	.fontBlue {
		color: rgba(25, 159, 255, 1) !important;
	}

	.public_oparetionBlock_Menu .pulic_carNumber {
		margin-top: 6px;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		font-size: 14px;
		display: inline-block;
	}

	.billOperationRecord .public_oparetionBlock_Menu {
		height: 45px;
		align-items: center;
	}

	.billOperationRecord {
		background-color: #f3f3f3;
	}

	.billOperationRecord th,
	.billOperationRecord td {
		text-align: center !important;
	}

	.carManagement {
		background: #f3f3f3;
	}

	.bcarManagement-table {
		padding: 30px 20px 0;
	}

	.test111:active {
		background-color: red !important;
	}

	/* 新增--列表宽度 */
	.billOperationRecord .systemCodePC-add-code-table-li-ipt {
		flex: 1.5;
	}

	.fontBlue {
		color: rgba(25, 159, 255, 1) !important;
	}

	.public_oparetionBlock_Menu .pulic_carNumber {
		margin-top: 6px;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		font-size: 14px;
		display: inline-block;
	}

	.billOperationRecord .public_oparetionBlock_Menu {
		height: 45px;
		align-items: center;
	}

	.billOperationRecord {
		background-color: #f3f3f3;
	}

	.billOperationRecord th,
	.billOperationRecord td {
		text-align: center !important;
	}

	/* 弹框 */
	.systemCodePC-add-code {
		padding: 0 20px;
	}

	.systemCodePC-add-code-table-li {
		display: flex;
		height: 40px;
		line-height: 40px;
		text-align: center;
	}

	.systemCodePC-add-code-table-li>div {
		border: 1px solid #CDCDCD;
		border-top: none;
	}

	.systemCodePC-add-code-table-li:first-child>div {
		border-top: 1px solid #CDCDCD;
	}

	.systemCodePC-add-code-table-li>div:first-child {
		border-right: none;
	}

	.systemCodePC-add-code-table-li>div:last-child {
		border: none;
	}

	.systemCodePC-add-code-table-li-name {
		flex: 1;
		background: rgba(240, 252, 255, 1);
	}

	.systemCodePC-add-code-table-li-ipt {
		flex: 1;
	}

	.systemCodePC-add-code-table-li-ipt input {
		height: 100%;
		width: 100%;
		border: none;
		vertical-align: top;
		box-sizing: border-box;
		text-align: center;
	}

	.systemCodePC-add-code-table-li-ipt input:focus {
		outline: none;
	}

	.systemCodePC-add-code-table-li-text {
		flex: .3;
		color: #FF4D35;
	}

	.systemCodePC-add-code-btn {
		margin-top: 20px;
		text-align: center;
	}

	.systemCodePC-pagesize {
		text-align: right;
		margin-top: 20px;
	}
</style>
<style>
	.demo-table-expand {
		font-size: 0;
	}

	.demo-table-expand label {
		width: 90px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.itemMsg {
		padding: 0 10px;
	}

	.demo-table-expand .item-lxxx .el-form-item__content {
		width: 500px;
	}

	.el-tag+.el-tag {
		margin-left: 10px;
	}

	.button-new-tag {
		margin-left: 10px;
		height: 22px;
		line-height: 30px;
		padding-top: 0;
		padding-bottom: 0;
	}

	.input-new-tag {
		width: auto;
		margin-left: 10px;
		vertical-align: baseline;
		/*vertical-align: bottom;*/
	}
</style>
